import { MeRepository, DevicesRepository } from 'common/repositories/index';
import { IssuesProcessor } from 'common/repositoryProcessors/index';
import eventManager from 'common/services/-RFC.eventManager';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';

/**
 * Header directive
 */

angular.module('directives')
    .directive('header', () => ({
        restrict: 'E',
        replace: true,
        template: require('./header.html'),
        scope: {},
        compile: () => ({
            pre: (scope) => {

                scope.User = MeRepository.getMyUser();
                scope.issueType = '';

                scope.referralCode = Session.getValue(SessionKeys.ReferralCode) || '';

            },
            post: (scope) => {

                scope.setIssueType = () => {

                    scope.issueType = '';
                    scope.instancesWithIssues = scope.instancesWithIssues || [];

                    if (scope.instancesWithIssues.length > 1) {

                        scope.issueType = 'multiple';


                    } else if (scope.instancesWithIssues.length === 1) {

                        const issue = scope.instancesWithIssues[0];
                        scope.device =
                                    DevicesRepository.getById(issue.relationships.device.data.id);

                        if (issue.attributes.status.svc.guard === 2 ||
                                    issue.attributes.status.svc.guard === 4) {

                            scope.issueType = 'guard';
                            return;

                        }
                        if (issue.attributes.status.svc.firewall === 2 ||
                                    issue.attributes.status.svc.firewall === 4) {

                            scope.issueType = 'firewall';
                            return;

                        }
                        if (issue.attributes.status.svc.mailguard === 2 ||
                                    issue.attributes.status.svc.mailguard === 4) {

                            scope.issueType = 'mailguard';
                            return;

                        }
                        if (issue.attributes.status.svc.webguard === 2 ||
                                    issue.attributes.status.svc.webguard === 4) {

                            scope.issueType = 'webguard';


                        }

                    }


                };

                // broadcast when the user mouseover the header
                scope.broadcastMouseOver = () => {

                    eventManager.broadcast('mainControlls:hover');

                };

                // direct binding for issues
                const issuesObservable = IssuesProcessor.getObservable();
                const issuesSubscriber = issuesObservable.subscribe((data) => {

                    scope.instancesWithIssues = _.values(data);
                    scope.setIssueType();

                }, () => { }, () => { });

                scope.$on('$destroy', () => {

                    issuesSubscriber.dispose();

                });

                // direct binding for devices
                const devicesObservable = DevicesRepository.getObservable();
                const onNextDevice = () => {

                    scope.setIssueType();

                };
                const devicesSubscriber =
                            devicesObservable.subscribe(onNextDevice, () => { }, () => { });

                scope.$on('$destroy', () => {

                    devicesSubscriber.dispose();

                });

            },
        }),
    }));



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/header/header.js